import React from "react";
import "./Product.css";
import { addImage } from "../Helpers";
import DefaultProductImage from "assets/images/default-product-image-128x160.jpg";

function handleDrop(e) {
  e.stopPropagation();
  e.preventDefault();
}

function handleDragOver(e) {
  e.stopPropagation();
  e.preventDefault();
}

function handleImageDragStart(event, productname, skuvalue, productcolorcode, productwprice, productrprice) {
  event.dataTransfer.setData("name", "image");
  event.dataTransfer.setData("imageUrl", event.target.src);
  event.dataTransfer.setData("productname", productname);
  event.dataTransfer.setData("productsku", skuvalue);
  event.dataTransfer.setData("productcolorcode", productcolorcode);
  event.dataTransfer.setData("productwprice", productwprice);
  event.dataTransfer.setData("productrprice", productrprice);
}

function setDefaultSrc(target) {
  target.onerror = null; // prevents looping
  target.src = DefaultProductImage;
}

function Product(props) {
  return (
  <div className="product" id={props.productsku}>
    <div className="productImage">
    <img src={props.productimg}
      onError={({ target }) => setDefaultSrc(target)}
      alt="" width={86} height={92}
      onClick={(event) => addImage(event.target.src, false, props.productname, props.productsku, props.productcolorcode, props.productwprice, props.productrprice)}
      onDragStart={(event) => handleImageDragStart(event, props.productname, props.productsku, props.productcolorcode, props.productwprice, props.productrprice)}
      onDrop={(event) => handleDrop(event)}
      onDragOver={(event) => handleDragOver(event)} />
    </div>
    <div className="productDetails">
    <h2 className="productName">{props.productname}</h2>
    <h4 className="productSku">
      <span className="skuText">Sku: </span>
      <span className="skuValue">{props.productsku}</span>
    </h4>
    </div>
  </div>
  );
}

export default Product;
